import * as React from 'react';
import { IconComment16 } from '@cian/ui-kit';

import * as styles from './ReviewAnswers.css';

export interface IReviewAnswersProps {
  url: string;
  answersCount: string;
}

export const ReviewAnswers: React.FC<IReviewAnswersProps> = ({ answersCount, url }) => {
  return (
    <a className={styles['component']} href={url}>
      <IconComment16 color="current_color" /> <div className={styles['label']}>{answersCount}</div>
    </a>
  );
};
